import { DisplayMode } from '../../draw-helpers';

/** Ключ кэша слота по размеру и режиму — общий формат для main и worker. */
export function makeSlotKey(slotWidth: number, slotHeight: number, mode: DisplayMode): string {
    return `${Math.round(slotWidth)}x${Math.round(slotHeight)}-${mode}`;
}
